document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("fbt-bundle");
  if (!root) return;

  // 1. POSITIONING: Form ke theek neeche right column mein shift karein
  function placeWidget() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm && productForm.parentNode) {
      if (productForm.nextSibling) {
        productForm.parentNode.insertBefore(root, productForm.nextSibling);
      } else {
        productForm.parentNode.appendChild(root);
      }
    }
  }
  placeWidget();
  setTimeout(placeWidget, 500);

  const productId = root.getAttribute("data-product-id");
  const currentAgeCohort = parseInt(root.getAttribute("data-age-cohort"), 10) || 0;
  const currencySymbol = root.getAttribute("data-currency-symbol") || "Rs.";
  const totalDisplay = document.getElementById("fbt-total-amount");
  const submitButton = document.getElementById("fbt-add-btn");
  const suggestedContainer = document.getElementById("fbt-suggested-list");

  function formatMoney(cents) {
    return currencySymbol + (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // Main product ka variant main page se sync karein
  function syncMainVariant() {
    const mainFormInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const mainCheckbox = root.querySelector('.fbt-main-item .fbt-checkbox');
    if (mainFormInput && mainCheckbox) {
      mainCheckbox.setAttribute('data-variant-id', mainFormInput.value);
    }
  }

  // 2. Price calculation
  function recalculateTotal() {
    syncMainVariant();
    let totalCents = 0;
    let checkedAddonsCount = 0;
    let isMainChecked = false;

    root.querySelectorAll(".fbt-checkbox:checked").forEach((cb) => {
      const item = cb.closest(".fbt-item");
      const price = parseInt(item.getAttribute("data-price"), 10) || 0;
      totalCents += price;

      if (cb.getAttribute("data-is-main") === "true") {
        isMainChecked = true;
      } else {
        checkedAddonsCount++;
      }
    });

    if (totalDisplay) {
      totalDisplay.innerText = formatMoney(totalCents);
    }

    if (submitButton) {
      if (!isMainChecked && checkedAddonsCount === 0) {
        submitButton.disabled = true;
        submitButton.innerText = "SELECT AN ITEM";
      } else {
        submitButton.disabled = false;
        if (checkedAddonsCount === 0) {
          submitButton.innerText = "ADD TO BASKET";
        } else if (checkedAddonsCount === 1) {
          submitButton.innerText = "ADD BOTH TO BASKET";
        } else {
          submitButton.innerText = `ADD ALL (${checkedAddonsCount + 1}) TO BASKET`;
        }
      }
    }
  }

  // 3. Machine Learning Order History (With Strict Age-Matching Gate)
  if (productId && suggestedContainer) {
    fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=complementary`)
      .then((res) => res.json())
      .then((data) => {
        if (data.products && data.products.length > 0) {
          const ageMatchedML = data.products.filter((p) => {
            if (p.id == productId || !p.available) return false;
            
            // Age cohort check on ML product
            const titleLower = p.title.toLowerCase();
            const varsLower = (p.variants || []).map(v => v.title).join(' ').toLowerCase();

            let prodCohort = 0;
            if (varsLower.includes('0-3m') || varsLower.includes('3-6m') || varsLower.includes('6-12m') || varsLower.includes('nb') || varsLower.includes('newborn') || titleLower.includes('newborn') || titleLower.includes('infant') || titleLower.includes('feeder')) {
              prodCohort = 1;
            } else if (varsLower.includes('1-2y') || varsLower.includes('2-3y') || varsLower.includes('12-18m') || titleLower.includes('toddler')) {
              prodCohort = 2;
            } else if (varsLower.includes('3-4y') || varsLower.includes('4-5y') || varsLower.includes('5-6y') || varsLower.includes('7-8y') || titleLower.includes('frock') || titleLower.includes('dress') || titleLower.includes('sando')) {
              prodCohort = 3;
            }

            // Reject if age cohort does not match
            if (currentAgeCohort > 0 && prodCohort > 0 && currentAgeCohort !== prodCohort) {
              return false;
            }
            return true;
          });

          if (ageMatchedML.length > 0) {
            renderMLSuggestedItems(ageMatchedML.slice(0, 2));
          }
        }
      })
      .catch((err) => console.debug("ML fallback active:", err));
  }

  function renderMLSuggestedItems(products) {
    let html = "";
    products.forEach((prod) => {
      const firstVariant = prod.variants[0];
      let variantSelect = "";

      if (prod.variants.length > 1) {
        variantSelect = `
          <div class="fbt-variant-box">
            <select class="fbt-variant-select">
              ${prod.variants
                .filter((v) => v.available)
                .map(
                  (v) =>
                    `<option value="v.id"data-price="{v.price}">${v.title}</option>`
                )
                .join("")}
            </select>
          </div>
        `;
      }

      html += `
        <div class="fbt-item fbt-addon-item" data-price="${firstVariant.price}">
          <div class="fbt-checkbox-col">
            <input type="checkbox" class="fbt-checkbox fbt-addon-checkbox" 
                   data-variant-id="${firstVariant.id}" 
                   aria-label="Select ${prod.title}">
          </div>
          <div class="fbt-image-col">
            <img src="prod.featuredimage"alt="{prod.title}" width="80" height="80" loading="lazy">
          </div>
          <div class="fbt-info-col">
            <span class="fbt-title">${prod.title}</span>
            ${variantSelect}
            <div class="fbt-price-box">
              <span class="fbt-price">${formatMoney(firstVariant.price)}</span>
            </div>
          </div>
        </div>
      `;
    });

    suggestedContainer.innerHTML = html;
    recalculateTotal();
  }

  // 4. Change Listeners
  root.addEventListener("change", function (e) {
    if (e.target.classList.contains("fbt-checkbox")) {
      const item = e.target.closest(".fbt-item");
      if (item && !item.classList.contains("fbt-main-item")) {
        if (e.target.checked) {
          item.classList.add("is-selected");
        } else {
          item.classList.remove("is-selected");
        }
      }
      recalculateTotal();
    }

    if (e.target.classList.contains("fbt-variant-select")) {
      const select = e.target;
      const option = select.options[select.selectedIndex];
      const item = select.closest(".fbt-item");
      const cb = item.querySelector(".fbt-checkbox");
      const priceTag = item.querySelector(".fbt-price");

      const price = parseInt(option.getAttribute("data-price"), 10);
      cb.setAttribute("data-variant-id", select.value);
      item.setAttribute("data-price", price);
      priceTag.innerText = formatMoney(price);

      recalculateTotal();
    }
  });

  // 5. BULLETPROOF MULTI-ADD TO CART (FormData based + Cart refresh)
  if (submitButton) {
    submitButton.addEventListener("click", function (e) {
      e.preventDefault();
      syncMainVariant();

      const items = [];
      root.querySelectorAll(".fbt-checkbox:checked").forEach((cb) => {
        const id = cb.getAttribute("data-variant-id");
        if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });

      if (items.length === 0) return;

      submitButton.disabled = true;
      submitButton.innerText = "ADDING TO BASKET...";

      const formData = new FormData();
      items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);
      });

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json"
        },
        body: formData
      })
        .then((res) => {
          if (!res.ok) throw new Error("Add to cart error " + res.status);
          return res.json();
        })
        .then((data) => {
          submitButton.innerText = "ADDED!";
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: data } }));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          setTimeout(() => {
            window.location.href = "/cart";
          }, 300);
        })
        .catch((err) => {
          console.error("Cart error fallback:", err);
          window.location.href = `/cart/add?id=${items[0].id}&quantity=1`;
        });
    });
  }

  recalculateTotal();
});


